<div class="invoice-list-container">
  <header class="header">
    <h1>{{ 'mainPage.title' | translate }}</h1>

    <div class="header-actions">
      <p-dropdown
        [options]="languages"
        [(ngModel)]="selectedLanguage"
        optionLabel="label"
        placeholder="{{ 'mainPage.selectLanguage' | translate }}"
        (onChange)="onLanguageChange($event.value)"
        styleClass="language-dropdown"
      ></p-dropdown>

      <p-button
        [label]="'mainPage.logout' | translate"
        icon="pi pi-sign-out"
        size="small"
        severity="secondary"
        (onClick)="signOut()"
      ></p-button>
    </div>
  </header>

  <h2 class="page-title">{{ 'invoiceList.title' | translate }}</h2>

  <p *ngIf="error()" class="error-message">{{ error() }}</p>
  <p *ngIf="isLoading()" class="loading-message">{{ 'invoiceList.loading' | translate }}</p>

  <p-table
    *ngIf="!isLoading() && !error()"
    [value]="invoices()"
    [paginator]="true"
    [rows]="5"
    [rowsPerPageOptions]="[5, 10, 20]"
    sortMode="multiple"
    responsiveLayout="scroll"
    class="p-datatable-gridlines p-shadow-2"
  >
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="job_id">
          {{ 'invoiceList.jobId' | translate }} <p-sortIcon field="job_id" />
        </th>
        <th scope="col" pSortableColumn="file_name">
          {{ 'invoiceList.fileName' | translate }} <p-sortIcon field="file_name" />
        </th>
        <th scope="col" pSortableColumn="customer_id">
          {{ 'invoiceList.customerId' | translate }} <p-sortIcon field="customer_id" />
        </th>
        <th scope="col" pSortableColumn="organization_id">
          {{ 'invoiceList.organizationId' | translate }} <p-sortIcon field="organization_id" />
        </th>
        <th scope="col" pSortableColumn="created_datetime">
          {{ 'invoiceList.receivedDate' | translate }} <p-sortIcon field="created_datetime" />
        </th>
        <th scope="col">{{ 'invoiceList.action' | translate }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-invoice>
      <tr>
        <td>{{ invoice.job_id }}</td>
        <td>{{ invoice.file_name }}</td>
        <td>{{ invoice.customer_id }}</td>
        <td>{{ invoice.organization_id }}</td>
        <td>{{ invoice.created_datetime | date: 'short' }}</td>
        <td class="action-wrapper">
          <div class="action-wrapper">
            <button
              pButton
              type="button"
              icon="pi pi-eye"
              class="p-button-sm p-button-info"
              (click)="viewInvoice(invoice)"
            >
              <span class="p-button-label">{{ 'invoiceList.startJob' | translate }}</span>
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-toast></p-toast>
</div>
